import Nullstack from 'nullstack';
export default function IconBuildingTunnel({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-tunnel",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 21h14a2 2 0 0 0 2 -2v-7a9 9 0 0 0 -18 0v7a2 2 0 0 0 2 2z"
  }), "   ", Nullstack.element("path", {
    d: "M8 21v-9a4 4 0 1 1 8 0v9"
  }), "   ", Nullstack.element("path", {
    d: "M3 17h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 17h4"
  }), "   ", Nullstack.element("path", {
    d: "M21 12h-4"
  }), "   ", Nullstack.element("path", {
    d: "M7 12h-4"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v5"
  }), "   ", Nullstack.element("path", {
    d: "M6 6l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M15 9l3 -3l-3 3z"
  }), " ");
}